import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';

import './assets/css/bootstrap.min.css'; 
import './assets/css/theme.min.css'; 
import './assets/vendors/css/vendors.min.css'; 
import './assets/vendors/css/dataTables.bs5.min.css'; 
import './assets/css/custom.css';

import $ from 'jquery';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if (!localStorage.getItem("app-skin-dark")) {
  localStorage.setItem("app-skin-dark", "app-skin-light");
} else {
  $("html").addClass(localStorage.getItem("app-skin-dark"));
}



// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
